import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getTripsAverageSpeedByVehicleId } from '../../services/TripsService';
import { TripsAverageSpeedResponse } from '../../types/Trips';

function useGetTripsAverageSpeedByVehicleId(fleetId: string, vehicleId: string): UseQueryResult<TripsAverageSpeedResponse> {
  return useQuery(
    ['trips-aggregation-avgSpeedMs', fleetId, vehicleId],
    async (): Promise<TripsAverageSpeedResponse> => getTripsAverageSpeedByVehicleId(fleetId, vehicleId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetTripsAverageSpeedByVehicleId;
